import React, {useEffect, useRef, useState} from 'react';
import gsap from 'gsap';
import {useParams, useNavigate} from 'react-router-dom';
import nl2br from 'react-nl2br';
import {detectAnyAdblocker} from 'just-detect-adblock';

import Data from '../../Data';
import styles from './Detail.module.scss';
import Button from '../Global/Button';
import Image from '../Global/Image';

import Swiper, {Navigation, Pagination, Parallax, Lazy} from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/parallax';
import Chevron from '../Pictos/Chevron';
import Close from '../Pictos/Close';
import {Link} from 'react-router-dom';

export default function Detail() {
    const navigate = useNavigate();
    const {slug} = useParams();

    const [detectedAdblock, setDetectedAdblock] = useState(false);
    const main = useRef(null);
    const [content, setContent] = useState(() => {});
    const [slider, setSlider] = useState(null);

    const [posts, setposts] = useState([]);

    useEffect(() => {
        if (main.current.getBoundingClientRect().height > window.innerHeight) {
            gsap.set(main.current, {
                minHeight: window.innerHeight - document.getElementById('Footer').getBoundingClientRect().height,
            });
        }

        detectAnyAdblocker().then(detected => setDetectedAdblock(() => detected))
    }, []);


    useEffect(() => {
        if (detectedAdblock) {
            const linksToChange = document.querySelectorAll(`.${styles.Text} a[href^="https://ad.doubleclick.net"]`);

            Object.values(linksToChange).map(link => link.href = link.dataset.href)
        }
    }, [detectedAdblock])

    useEffect(() => {
        if (posts.length === 0) {
            const tempposts = [...posts];

            Data.map(group => {
                group.map(box => {
                    if (box.slug) {
                        if (box.slug === slug) {
                            setContent(() => box);
                        }

                        tempposts.push(box);
                    }
                    else {
                        box.map(item => {
                            if (item.slug) {
                                if (item.slug === slug) {
                                    setContent(() => item);
                                }

                                tempposts.push(item);
                            }
                        });
                    }

                });
            });

            setposts(() => tempposts);
        }

        window.page = slug;
    }, [Data, slug]);

    useEffect(() => {
        if (content) {

            const s = new Swiper('.swiper', {
                modules: [Navigation, Pagination, Parallax, Lazy],
                slidesPerView: 1,
                initialSlide: posts.findIndex(item => item.slug === slug),
                autoHeight: true,
                parallax: true,
                lazy: true,
                navigation: {
                    prevEl: '.swiper-prev', nextEl: '.swiper-next',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                }
            });

            s.on('slideChange', (e) => {
                window.scrollTo({
                    top: 0, left: 0,
                    behavior: 'smooth'
                });

                if (posts[e.realIndex]) {
                    const _slug = posts[e.realIndex].slug;
                    window.page = _slug;

                    navigate(`/evenement/${_slug}`);
                }
            });

            gsap.to(s.$el, .3, {
                opacity: 1,
                delay: 1,
            });

            setSlider(s);
        }
    }, [posts, navigate, slug, content]);

    useEffect(() => {
        if (slider) {
            slider.init();
        }
    }, [slider]);

    return (
        <section ref={main} className={styles.Main}>
            <div className="container">
                <div className={'swiper'}>
                    <div className={styles.Meta}>
                        <div className="container">
                            <Link to={'/'}>
                                <Close/>
                            </Link>
                            <div className={styles.Controls}>
                                <nav className={styles.Navigation}>
                                    <button className={'swiper-prev'}>
                                        <Chevron/>
                                    </button>
                                    <span className={'swiper-pagination'}>{posts ? <><span className={'swiper-pagination-current'}>{posts.findIndex(item => item.slug === slug) + 1}</span> / <span className={'swiper-pagination-total'}>{posts.length}</span></> : null}</span>
                                    <button className={'swiper-next'}>
                                        <Chevron/>
                                    </button>
                                </nav>

                                <span className={styles.Page}>{posts[slider?.realIndex]?.page}</span>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-wrapper">
                        {
                            posts.map(item => {
                                const src = require(`../../images/details/${item.slug}.jpg`);
                                const srcRet = require(`../../images/details/${item.slug}@2x.jpg`);
                                const webp = require(`../../images/details/${item.slug}.webp`);
                                const webpRet = require(`../../images/details/${item.slug}@2x.webp`);

                                return (
                                    <article className={[styles.Article, 'swiper-slide'].join(' ')} key={item.slug}>
                                        <div className={styles.Image} data-swiper-parallax="-50">
                                            <Image {...{src, srcRet, webp, webpRet}}/>
                                        </div>
                                        <div className={styles.Content} data-swiper-parallax="500">
                                            <h2 dangerouslySetInnerHTML={{__html: item?.title}}/>

                                            <p className={styles.Text} dangerouslySetInnerHTML={{__html: item?.text}}/>

                                            {
                                                item.button ? <Button url={item.button.track && !detectedAdblock ? item.button.track : item.button.url} text={item.button.text} external={true}/> : null
                                            }

                                            <p className={[styles.Disclaimer, 'small'].join(' ')} dangerouslySetInnerHTML={{__html: item?.disclaimer}}/>
                                        </div>

                                        {
                                            item?.print.map(print =>
                                                <img key={print} className={'swiper-lazy'} data-src={'https://ad.doubleclick.net/ddm/ad/N1224350.159115BOURSIER/'+print+';sz=1x1;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755}?'} border="0" width="1" height="1" alt="Advertisement"/>
                                            )
                                        }
                                    </article>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}